import { useState } from 'react'

export default function TextArea (props) {
    const [charsLength, setCharsLength]
        = useState((props.defaultValue || '').length)

    const { onBlur, onChange, onKeyUp, ...renderProps } = props

    const onBlurHandler = (e) => {
        e.target.value = (e.target.value || '').trim()

        setCharsLength(e.target.value.length)

        if (typeof onBlur === 'function')
            onBlur(e)
    }

    const onChangeHandler = (e) => {
        setCharsLength(e.target.value.length)

        if (e.type === 'keyup'
                && typeof onKeyUp === 'function')
            onKeyUp(e)

        if (e.type === 'change'
                && typeof onChange === 'function')
            onChange(e)
    }

    const describedby = props.maxLength
        && props.id
        && `${props.id}-chars`

    if (describedby)
        renderProps['aria-describedby'] = `${
            renderProps['aria-describedby'] || ''} ${
            describedby}`.trim()

    return (
        <>
            <textarea
                {...renderProps}
                onBlur={onBlurHandler}
                onChange={onChangeHandler}
                onKeyUp={onChangeHandler}
            />
            {props.maxLength
                && (
                    <p
                        id={props.id
                            && `${props.id}-chars`}
                        className="body-4"
                    >
                        {charsLength}/{props.maxLength} characters.
                    </p>
                )}
        </>
    )
}
